import { PERIOD_OPTIONS } from "../consts";
import { AppliedFilter } from "./_filters";
import { formatDate } from "./_generic";

type SearchTypeKey = "jurisprudencia" | "legislacao" | "doutrinas" | "modelos";

type AppliedFiltersMap = Record<SearchTypeKey, AppliedFilter[]>;

interface BuildDisplayedFiltersParams {
  appliedFilters: AppliedFiltersMap;
  currentSearchType: keyof AppliedFiltersMap;
  modalTypeAppliedFilters: string[];
  appliedModelType: string;
  currentPeriod: {
    endDate: string | null;
    period: string;
    startDate: string | null;
  };
  selectedPersonFilter: string;
  personFilter: { label: string };
}

export function buildDisplayedFilters({
  appliedFilters,
  currentSearchType,
  modalTypeAppliedFilters,
  appliedModelType,
  currentPeriod,
  selectedPersonFilter,
  personFilter,
}: BuildDisplayedFiltersParams) {
  const filters: Array<{
    type: string;
    label: string;
    value?: string | null;
    startDate?: string | null;
    endDate?: string | null;
  }> = [];

  const currentAppliedFilterValues =
    appliedFilters[currentSearchType]?.flatMap(
      (filter: any) => filter.values
    ) ?? [];

  currentAppliedFilterValues.forEach((value: string) => {
    filters.push({
      type: "normal",
      label: value,
    });
  });

  if (currentSearchType === "modelos") {
    modalTypeAppliedFilters.forEach((value) => {
      filters.push({
        type: "modelTypeFilter",
        label: value,
      });
    });

    if (appliedModelType !== "all") {
      filters.push({
        type: "modelType",
        label:
          appliedModelType.charAt(0).toUpperCase() + appliedModelType.slice(1),
      });
    }
  }

  if (currentPeriod?.period && currentPeriod.period !== "always") {
    filters.push({
      type: "period",
      label:
        currentPeriod.period === "custom"
          ? `${formatDate(currentPeriod.startDate)} - ${formatDate(
              currentPeriod.endDate
            )}`
          : PERIOD_OPTIONS[currentPeriod.period as keyof typeof PERIOD_OPTIONS]
              ?.title ?? "Período personalizado",
      value: currentPeriod.period,
      startDate: currentPeriod.startDate,
      endDate: currentPeriod.endDate,
    });
  }

  if (selectedPersonFilter) {
    filters.push({
      type: "person",
      label: `${personFilter.label}: ${selectedPersonFilter}`,
      value: selectedPersonFilter,
    });
  }

  return filters;
}
